import React from 'react'
import { Label, SwitchDiv } from './styles'
import { SwitchToggle } from 'components/SwitchToggle'
import { Control, FieldValues } from 'react-hook-form'

interface CustomToggleProps {
  enabled: boolean
  name?: string
  label?: string
  leftText: string
  rightText: string
  setEnabled: (b: boolean) => void
  control?: Control<FieldValues, any>
}

const CustomToggle: React.FC<CustomToggleProps> = ({
  enabled,
  setEnabled,
  name,
  control,
  label,
  leftText,
  rightText
}) => {
  const isEnabled = enabled
    ? 'text-darkGray/80'
    : 'text-darkGray font-semibold'

  const isNotEnable = !enabled
    ? 'text-darkGray/80'
    : 'text-darkGray font-semibold'

  return (
    <div>
      <Label>{label}</Label>
      <SwitchDiv>
        <span className={isEnabled}>{leftText}</span>
        <SwitchToggle
        name={name}
        control={control}
          enabled={enabled}
          setEnabled={setEnabled} />
        <span className={isNotEnable}>{rightText}</span>
      </SwitchDiv>
    </div>
  )
}

export { CustomToggle }
